import React from 'react';
import {
  Box, Card, CardContent, Grid, IconButton, Paper, Stack, Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

interface DailyWorkoutLogsProps {
  selectedDate: string;
  logsLoading: boolean;
  logs: any[]; // array of logs for the selected date
  onEdit: (log: any) => void;
  onDelete: (id: string) => void;
}

export const DailyWorkoutLogs: React.FC<DailyWorkoutLogsProps> = ({
  selectedDate,
  logsLoading,
  logs,
  onEdit,
  onDelete,
}) => {
  return (
    <Grid item xs={12} md={6}>
      <Paper sx={{ p: 3, minHeight: 200 }}>
        <Typography variant="h6" gutterBottom>Workouts on this Day</Typography>
        {logsLoading ? (
          <Typography variant="body2" color="text.secondary">Loading...</Typography>
        ) : logs.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No workouts logged for this date.</Typography>
        ) : (
          <Stack spacing={2}>
            {logs.map((log: any) => (
              <Card key={log.id} variant="outlined">
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">{log.exercise.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {log.exercise.category} • {log.exercise.equipment}
                      </Typography>
                    </Box>
                    <Box>
                      <IconButton size="small" color="primary" onClick={() => onEdit(log)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton size="small" color="error" onClick={() => onDelete(log.id)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {log.sets.map((s: any, i: number) => (
                      <Paper key={i} variant="outlined" sx={{ px: 1, py: 0.5, bgcolor: s.completed ? 'action.hover' : 'inherit' }}>
                        <Typography variant="caption">
                          Set {i + 1}: {s.weight}kg x {s.reps}
                        </Typography>
                      </Paper>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Stack>
        )}
      </Paper>
    </Grid>
  );
};
